/*doc

 Renders a widget containing author name, questions answered
 most recent book, picture, Ask button if they are currently enabled
 for Ask The Author, and their most recently answered question.

 */

import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import React from "react";
import Spoiler from "../../../user_content/spoiler";
import FlagForAbuseLink from "../../../flagged_resources/flag_for_abuse_link";
import ExpandableHtml from "../../../user_content/expandable_html";
import LikesAndCommentsFooter from "../../../like/likes_and_comments_footer";
import SpoilerWarning from "../shared/spoiler_warning";

const cssPrefix = "askTheAuthorCommunityQuestionAnswerContainer";

export default GrComponentFactory.createClass({
  displayName: "CommunityQuestionAnswerContainer",

  propTypes: {
    authorUser: GrPropTypes.author().isRequired,
    currentUser: GrPropTypes.user().isRequired,
    communityQuestionText: React.PropTypes.string.isRequired,
    communityAnswerText: React.PropTypes.shape(GrPropTypes.truncatedHtml()),
    questionSpoiler: React.PropTypes.bool.isRequired,
    answerSpoiler: React.PropTypes.bool.isRequired,
    flagForAbuseUrl: React.PropTypes.string.isRequired,
    like: GrPropTypes.like().isRequired,
    comment: GrPropTypes.comment().isRequired,
  },
  renderAuthorAnswer(){
    return (
      <div className={`${cssPrefix}__answerContainer`}>
        <a className={`${cssPrefix}__authorName gr-hyperlink`}
           href={this.props.authorUser.profileUrl}>
             {this.props.authorUser.name}: </a>
        {this.props.answerSpoiler ?
          <Spoiler html={this.props.communityAnswerText.fullContentText}
                   spoilerWarning={<SpoilerWarning spoilerType="answer"/>} /> :
        <ExpandableHtml html={this.props.communityAnswerText.fullContentText}
                        truncatedHtml={this.props.communityAnswerText.html}
                        className={`${cssPrefix}__answerText`}/>
      }
      </div>
    );
  },
  renderAuthorQuestion(){
    return (
      <div className={`${cssPrefix}__questionText`}>
        {this.props.questionSpoiler ?
          <Spoiler html={this.props.communityQuestionText}
                   spoilerWarning={<SpoilerWarning spoilerType="question"/>} /> :
          this.props.communityQuestionText}
      </div>
    );
  },
  renderLikesAndCommentsFooter(){
    return (
      <div className={`${cssPrefix}__likesCommentsFooter u-marginTopXSmall u-marginBottomSmall`}>
        <LikesAndCommentsFooter
          currentUser={this.props.currentUser}
          resourceKey={this.props.like.key}
          resourceLabel={this.props.like.label}
          isLikeable={this.props.like.isLikeable}
          showAsLink={true}
          comment={this.props.comment}
        />
      </div>
    );
  },
  renderFlagForAbuseUrl(){
    return (
      <div className={`${cssPrefix}__flagButton gr-comment gr-comment__rightSideInformation`}>
        <FlagForAbuseLink flagForAbuseUrl={this.props.flagForAbuseUrl} />
      </div>
    );
  },
  render() {
    return (
      <div className={`${cssPrefix} gr-mediaFlexbox`}>
        <div>
          {this.renderAuthorQuestion()}
          {this.renderAuthorAnswer()}
          {this.renderLikesAndCommentsFooter()}
        </div>
      </div>
    );
  },
});
